import { ISchemaInput, ISIBare, ISIConst, ISIEnum, NestedSchema, RootSchema, TD } from '../union';
import { IsNever, SchemaTypeName } from './core';
import { ISchemaInteger } from './integer.types';

export * from './integer.types';

/**
 * Property value is an integer or array of integers
 */
export function integer<EnumVal extends TD<ISchemaInteger>>(
    schema: RootSchema<ISchemaInput<ISchemaInteger, ISIEnum<ISchemaInteger, EnumVal>>>
): ISchemaInteger<EnumVal>;
export function integer<EnumVal extends TD<ISchemaInteger>>(
    schema: NestedSchema<ISchemaInput<ISchemaInteger, ISIEnum<ISchemaInteger, EnumVal>>>
): NestedSchema<ISchemaInteger<EnumVal>>;
export function integer<ConstVal extends TD<ISchemaInteger>>(
    schema: RootSchema<ISchemaInput<ISchemaInteger, ISIConst<ISchemaInteger, ConstVal>>>
): ISchemaInteger<ConstVal>;
export function integer<ConstVal extends TD<ISchemaInteger>>(
    schema: NestedSchema<ISchemaInput<ISchemaInteger, ISIConst<ISchemaInteger, ConstVal>>>
): NestedSchema<ISchemaInteger<ConstVal>>;
export function integer(
    schema: RootSchema<ISchemaInput<ISchemaInteger, ISIBare<ISchemaInteger>>>
): RootSchema<ISchemaInteger>;
export function integer(
    schema: NestedSchema<ISchemaInput<ISchemaInteger, ISIBare<ISchemaInteger>>>
): NestedSchema<ISchemaInteger>;
export function integer(schema: ISchemaInput<ISchemaInteger>): ISchemaInteger {
    return {
        type: SchemaTypeName.integer,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = integer({ description: '', $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = integer({ description: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
